import {queryAll, command, queryOne, querySearch} from '../utils/api';

const SUPPLIERS_QUERY_URL = `${process.env.PUBLIC_URL}/api/v1/r/suppliers`;
export const GET_SUPPLIERS = 'GET_SUPPLIERS';
export const GET_SUPPLIERS_COMPLETED = 'GET_SUPPLIERS_COMPLETED';
export const GET_SUPPLIERS_FAILED = 'GET_SUPPLIERS_FAILED';

export function getSuppliers({salonId}) {
  const queryFilter = {
    where: {salonId: {eq: salonId}},
    order: "name ASC"
  };
  return queryAll(SUPPLIERS_QUERY_URL, queryFilter, GET_SUPPLIERS, GET_SUPPLIERS_COMPLETED, GET_SUPPLIERS_FAILED);
}

export const SEARCH_SUPPLIERS = 'SEARCH_SUPPLIERS';
export const SEARCH_SUPPLIERS_COMPLETED = 'SEARCH_SUPPLIERS_COMPLETED';
export const SEARCH_SUPPLIERS_FAILED = 'SEARCH_SUPPLIERS_FAILED';
export const searchSuppliers = querySearch(SUPPLIERS_QUERY_URL, SEARCH_SUPPLIERS, SEARCH_SUPPLIERS_COMPLETED,
  SEARCH_SUPPLIERS_FAILED, ['name', 'description']);

export const GET_SUPPLIER = 'GET_SUPPLIER';
export const GET_SUPPLIER_COMPLETED = 'GET_SUPPLIER_COMPLETED';
export const GET_SUPPLIER_FAILED = 'GET_SUPPLIER_FAILED';

export function getSupplier({supplierId}) {
  const filter = {
    where: {supplierId}
  };
  return queryOne(SUPPLIERS_QUERY_URL, filter, GET_SUPPLIER, GET_SUPPLIER_COMPLETED, GET_SUPPLIER_FAILED);
}

const SUPPLIER_ACTION_URL = `${process.env.PUBLIC_URL}/api/v1/supplier`;
export const ADD_SUPPLIER = 'ADD_SUPPLIER';
export const ADD_SUPPLIER_COMPLETED = 'ADD_SUPPLIER_COMPLETED';
export const ADD_SUPPLIER_FAILED = 'ADD_SUPPLIER_FAILED';
export const addSupplier = command(
  SUPPLIER_ACTION_URL + '/addSupplier',
  ADD_SUPPLIER,
  ADD_SUPPLIER_COMPLETED,
  ADD_SUPPLIER_FAILED
);

export const UPDATE_SUPPLIER = 'UPDATE_SUPPLIER';
export const UPDATE_SUPPLIER_COMPLETED = 'UPDATE_SUPPLIER_COMPLETED';
export const UPDATE_SUPPLIER_FAILED = 'UPDATE_SUPPLIER_FAILED';
export const updateSupplier = command(
  SUPPLIER_ACTION_URL + '/updateSupplier',
  UPDATE_SUPPLIER,
  UPDATE_SUPPLIER_COMPLETED,
  UPDATE_SUPPLIER_FAILED
);

export const DELETE_SUPPLIER = 'DELETE_SUPPLIER';
export const DELETE_SUPPLIER_COMPLETED = 'DELETE_SUPPLIER_COMPLETED';
export const DELETE_SUPPLIER_FAILED = 'DELETE_SUPPLIER_FAILED';
export const deleteSupplier = command(
  SUPPLIER_ACTION_URL + '/deleteSupplier',
  DELETE_SUPPLIER,
  DELETE_SUPPLIER_COMPLETED,
  DELETE_SUPPLIER_FAILED
);

export const SHOW_DELETE_SUPPLIER_MODAL = 'SHOW_DELETE_SUPPLIER_MODAL';
export function showDeleteSupplierModal(supplier) {
  return {type: SHOW_DELETE_SUPPLIER_MODAL, payload: supplier};
}

export const HIDE_DELETE_SUPPLIER_MODAL = 'HIDE_DELETE_SUPPLIER_MODAL';
export function hideDeleteSupplierModal() {
  return {type: HIDE_DELETE_SUPPLIER_MODAL};
}

export const EMAIL_ORDER_TO_SUPPLIER = 'EMAIL_ORDER_TO_SUPPLIER';
export const EMAIL_ORDER_TO_SUPPLIER_COMPLETED = 'EMAIL_ORDER_TO_SUPPLIER_COMPLETED';
export const EMAIL_ORDER_TO_SUPPLIER_FAILED = 'EMAIL_ORDER_TO_SUPPLIER_FAILED';
export const emailOrderToSupplier = command(
  SUPPLIER_ACTION_URL + '/emailOrderToSupplier',
  EMAIL_ORDER_TO_SUPPLIER,
  EMAIL_ORDER_TO_SUPPLIER_COMPLETED,
  EMAIL_ORDER_TO_SUPPLIER_FAILED
);

const SUPPLIER_ORDERS_QUERY_URL = `${process.env.PUBLIC_URL}/api/v1/r/supplierOrders`;
export const SEARCH_SUPPLIER_ORDERS = 'SEARCH_SUPPLIER_ORDERS';
export const SEARCH_SUPPLIER_ORDERS_COMPLETED = 'SEARCH_SUPPLIER_ORDERS_COMPLETED';
export const SEARCH_SUPPLIER_ORDERS_FAILED = 'SEARCH_SUPPLIER_ORDERS_FAILED';
export const searchSupplierOrders = querySearch(SUPPLIER_ORDERS_QUERY_URL, SEARCH_SUPPLIER_ORDERS,
  SEARCH_SUPPLIER_ORDERS_COMPLETED, SEARCH_SUPPLIER_ORDERS_FAILED, ['createdAt'], {defaultOrder:'createdAt DESC'});

export const GET_SUPPLIER_ORDER = 'GET_SUPPLIER_ORDER';
export const GET_SUPPLIER_ORDER_COMPLETED = 'GET_SUPPLIER_ORDER_COMPLETED';
export const GET_SUPPLIER_ORDER_FAILED = 'GET_SUPPLIER_ORDER_FAILED';

export function getSupplierOrder({supplierOrderId}) {
  const filter = {
    where: {supplierOrderId}
  };
  return queryOne(SUPPLIER_ORDERS_QUERY_URL, filter, GET_SUPPLIER_ORDER, GET_SUPPLIER_ORDER_COMPLETED,
    GET_SUPPLIER_ORDER_FAILED);
}



// WEBPACK FOOTER //
// ./src/Supplier/actions.js